import setCurrentPage from "src/Utils/setCurrentPage";
import ConversationEffect from "src/Animations/ConversationEffect";

export const DATA_ND_DEMO_TCA_4 = {
  title: "Explore in-depth details of \nonboarded service/NF templates",
  subtitle: "Network designer",
  text: "Navigate infrastructure requirements, instantiation levels, and\n service templates integrating network functions to optimize\n your planning exercise.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_310"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => {
      setCurrentPage("ILO_308");
    },
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/TCA/TCA_Demo_bg.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ILO/TCA/TCA_ND_Demo_4_Screen_1.png",
          imageStyle: { paddingTop: "144px" },
        },
        {
          image: "ILO/TCA/TCA_ND_Demo_4_Screen_2.png",
          imageStyle: { position: "absolute", right: "0", top: "0" },
        },
      ]}
      conversationStyle={{ width: "auto" }}
      pageNumber={"ILO_309"}
    />
  ),
};
